module.exports = __webpack_public_path__ + "static/media/pov_wireframe_polytope_3_3_5_cell600.7a51d94b.png";